import React, { createContext, useRef, useContext } from 'react'

const GlobalContext = createContext()
export function GlobalContextProvider({ children }) {
  const googleLoginDomRef = useRef(null)
  const setGoogleLoginDomRef = (el) => {
    googleLoginDomRef.current = el
  }
  
  return (
    <GlobalContext.Provider value={{ googleLoginDomRef, setGoogleLoginDomRef }}>
      {children}
    </GlobalContext.Provider>
  )
}
export function useGlobalContext() {
  return useContext(GlobalContext)
}
